import React, { useState } from 'react';
import './FeedbackItem.css';

function FeedbackItem({ feedback, isAdmin, onStatusUpdate }) {
  const [updating, setUpdating] = useState(false);

  const handleStatusChange = async (newStatus) => {
    if (!isAdmin || updating) return;

    setUpdating(true);

    try {
      const response = await fetch('/backend/api/feedback/update-status.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          feedback_id: feedback.id,
          status: newStatus
        })
      });

      const data = await response.json();

      if (data.success) {
        onStatusUpdate();
      } else {
        alert(data.error || 'Failed to update status');
      }
    } catch (error) {
      console.error('Error updating status:', error);
      alert('Network error. Please try again.');
    } finally {
      setUpdating(false);
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 'pending': return 'status-pending';
      case 'fixed': return 'status-fixed';
      case 'implemented': return 'status-implemented';
      default: return '';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'pending': return 'Pending';
      case 'fixed': return 'Fixed';
      case 'implemented': return 'Implemented';
      default: return status;
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const avatarSrc = feedback.profile_avatar 
    ? `/assets/Profile/${feedback.profile_avatar}` 
    : '/assets/Profile/temp-usr.svg';

  return (
    <div className="feedback-item">
      <div className="feedback-header">
        <div className="user-info">
          <img src={avatarSrc} alt="User avatar" className="user-avatar" />
          <div className="user-details">
            <div className="user-name">{feedback.first_name} {feedback.last_name}</div>
            <div className="feedback-date">{formatDate(feedback.created_at)}</div>
          </div>
        </div>
        
        <div className="feedback-status">
          <span className={`status-badge ${getStatusClass(feedback.status)}`}>
            {getStatusText(feedback.status)}
          </span>
        </div>
      </div>

      <div className="feedback-content">
        <h3 className="feedback-title">{feedback.title}</h3>
        <p className="feedback-description">{feedback.description}</p>
      </div>

      {isAdmin && feedback.status === 'pending' && (
        <div className="feedback-actions">
          <button
            className="btn-action btn-fixed"
            onClick={() => handleStatusChange(feedback.type === 'error' ? 'fixed' : 'implemented')}
            disabled={updating}
          >
            {updating ? 'Updating...' : (feedback.type === 'error' ? 'Mark as Fixed' : 'Mark as Implemented')}
          </button>
        </div>
      )}
    </div>
  );
}

export default FeedbackItem;
